import { useMutation } from "@tanstack/solid-query";
import { devLog } from "@/libs/dev-log";

const submitFeedback = async (feedback: string) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      devLog("feedback", feedback);
      Math.random() > 0.5 ? resolve(true) : reject(new Error("test"));
    }, 1000);
  });
};

const useSubmitFeedback = () => {
  return useMutation(() => ({
    mutationFn: submitFeedback,
  }));
};

export { useSubmitFeedback };
